const galleryData = [
  // Storytelling
  {
    id: 1,
    src: "/images/gallery/1.jpg",
    sizeClass: "large-portrait",
    section: "Storytelling",
    alt: "Storytelling Image 1 - Large Portrait",
  },
  {
    id: 2,
    src: "/images/gallery/2.jpg",
    sizeClass: "medium-portrait",
    section: "Storytelling",
    alt: "Storytelling Image 2 - Medium Portrait",
  },
  {
    id: 3,
    src: "/images/gallery/3.jpg",
    sizeClass: "large-portrait",
    section: "Storytelling",
    alt: "Storytelling Image 3 - Large Portrait",
  },
  {
    id: 4,
    src: "/images/gallery/4.jpg",
    sizeClass: "medium-portrait",
    section: "Storytelling",
    alt: "Storytelling Image 4 - Medium Portrait",
  },
  {
    id: 5,
    src: "/images/gallery/5.jpg",
    sizeClass: "small-portrait",
    section: "Storytelling",
    alt: "Storytelling Image 5 - Small Portrait",
  },
  {
    id: 6,
    src: "/images/gallery/6.png",
    sizeClass: "small-portrait",
    section: "Storytelling",
    alt: "Storytelling Image 6 - Small Portrait",
  },
  {
    id: 7,
    src: "/images/gallery/7.jpg",
    sizeClass: "large-portrait",
    section: "Storytelling",
    alt: "Storytelling Image 7 - Large Portrait",
  },
  // Portraits
  {
    id: 8,
    src: "/images/gallery/8.png",
    sizeClass: "medium-square",
    section: "Portraits",
    alt: "Portraits Image 8 - Medium Square",
  },
  {
    id: 9,
    src: "/images/gallery/9.jpg",
    sizeClass: "medium-portrait",
    section: "Portraits",
    alt: "Portraits Image 9 - Medium Portrait",
  },
  {
    id: 10,
    src: "/images/gallery/10.png",
    sizeClass: "small-landscape",
    section: "Portraits",
    alt: "Portraits Image 10 - Small Landscape",
  },
  {
    id: 11,
    src: "/images/gallery/11.jpg",
    sizeClass: "small-portrait",
    section: "Portraits",
    alt: "Portraits Image 11 - Small Portrait",
  },
  {
    id: 12,
    src: "/images/gallery/12.jpg",
    sizeClass: "large-portrait",
    section: "Portraits",
    alt: "Portraits Image 12 - Large Portrait",
  },
  {
    id: 13,
    src: "/images/gallery/13.jpeg",
    sizeClass: "small-portrait",
    section: "Portraits",
    alt: "Portraits Image 13 - Small Portrait",
  },
  {
    id: 14,
    src: "/images/gallery/14.jpg",
    sizeClass: "small-portrait",
    section: "Portraits",
    alt: "Portraits Image 14 - Small Portrait",
  },
  {
    id: 15,
    src: "/images/gallery/15.jpg",
    sizeClass: "small-portrait",
    section: "Portraits",
    alt: "Portraits Image 15 - Small Portrait",
  },
  // Performance
  {
    id: 16,
    src: "/images/gallery/16.jpeg",
    sizeClass: "large-portrait",
    section: "Performance",
    alt: "Performance Image 16 - Large Portrait",
  },
  {
    id: 17,
    src: "/images/gallery/17.jpeg",
    sizeClass: "medium-portrait",
    section: "Performance",
    alt: "Performance Image 17 - Medium Portrait",
  },
  {
    id: 18,
    src: "/images/gallery/18.jpeg",
    sizeClass: "small-landscape",
    section: "Performance",
    alt: "Performance Image 18 - Small Landscape",
  },
  // Mixed Media
  {
    id: 19,
    src: "/images/gallery/19.jpg",
    sizeClass: "medium-portrait",
    section: "Mixed Media",
    alt: "Mixed Media Image 19 - Medium Portrait",
  },
  {
    id: 20,
    src: "/images/gallery/20.png",
    sizeClass: "medium-portrait",
    section: "Mixed Media",
    alt: "Mixed Media Image 20 - Medium Portrait",
  },
  {
    id: 21,
    src: "/images/gallery/21.jpg",
    sizeClass: "medium-portrait",
    section: "Mixed Media",
    alt: "Mixed Media Image 21 - Medium Portrait",
  },
  {
    id: 22,
    src: "/images/gallery/22.png",
    sizeClass: "mixed-media-featured-landscape",
    section: "Mixed Media",
    alt: "Mixed Media Image 22 - Large Landscape",
  },
  // New image added to Performance section
  {
    id: 23,
    src: "/images/gallery/23.jpg",
    sizeClass: "medium-portrait",
    section: "Performance",
    alt: "Performance Image 23 - Medium Portrait",
  },
];

export default galleryData;
